<div class="container-fluid" *ngIf="user">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
      <div class="container mt-5 pt-5">
        <div class="row g-0">
          <div>
            <mnf-authentication-first-screen *ngIf="step === 1" (form)="stepOne($event)" [user]="user"></mnf-authentication-first-screen>
            <mnf-authentication-second-screen *ngIf="step === 2" (returnStep)="returnStep($event)" (form)="stepTwo()" [user]="user"></mnf-authentication-second-screen>
            <mnf-authentication-fourth-screen *ngIf="step === 3" (returnStep)="returnStep($event)" (form)="stepFourth($event)" [user]="user"></mnf-authentication-fourth-screen>
            <mnf-authentication-third-screen *ngIf="step === 4" (returnStep)="returnStep($event)" (form)="stepThree($event)" [user]="user"></mnf-authentication-third-screen>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
